export function searchClear() {

    let className = "filled";
    let inputWrapper = ".search-form .form-item";


    if ($(inputWrapper).find("input[type=text]").val().length != 0) {
        $(inputWrapper).addClass(className)
    }

    $("input").focus(function () {
        $(this).parents(inputWrapper).addClass(className);
    }).blur(function () {
        let inputIsEmpty = $(this).val().length === 0;

        if (inputIsEmpty) {
            $(this).parents(inputWrapper).removeClass(className);
        }
    });

    $(inputWrapper).find(".reset").on("click", function (e) {
        e.preventDefault();
        $(inputWrapper).removeClass(className).find("input[type=text]").val("");
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/searchClear.js